<template lang="pug">
section.section(
    :class="classes"
    @click="editSection"
)
    include /components/Page/Sections/base.pug
    .content-wrappers(v-if="!isEmpty || $slots.default")
        slot
        template(v-if="!disabled")
            .preview(v-if="!isEmpty && categoryOptions.length")
                //- wrap el-tag to bypass transition
                .content-wrapper
                    .categories
                        el-tag(
                            v-for="category in section.shopCategories"
                            type="info"
                            :key="category.key"
                            size="large"
                            effect="dark"
                        ) {{ getBreadcrumb(category) }}
                    .tags(v-if="tagsEditable && tags.length")
                        el-tag(
                            v-for="tag in section.shopTags"
                            type="info"
                            :key="tag.key"
                            size="small"
                            effect="dark"
                        ) {{ tag.name }}

            .error(v-if="!categoryOptions.length")
                el-alert(type="warning" :title="$t('This shop has no categories yet!')")

    el-drawer.full-height-drawer.visible-overflow(
        v-if="editable"
        :title="$t('Edit {section}', { section: section.name })"
        :visible.sync="scopedUI.form"
        :before-close="confirmDiscard(() => changedSince(drawer.sectionSnapshot, drawer.section))"
        :wrapper-closable="false"
        :append-to-body="true"
        size="920px"
        :modal="true"
        @closed="resetDrawer"
    )
        .drawer-body(v-loading="drawer.loading")
            el-tabs(
                v-if="!drawer.loading"
                v-model="drawer.tab"
                tab-position="top"
            )
                el-tab-pane(name="content" :label="$t('Content')")
                    .tab-content
                        .content-wrapper
                            el-form-item(:label="$t('Categories')")
                                //- :value-consists-of="'ALL'"
                                //- :flat="true"
                                Treeselect(
                                    v-model="categories"
                                    placeholder=""
                                    :multiple="true"
                                    :options="categoryOptions"
                                    :default-expand-level="Infinity"
                                    :close-on-select="false"
                                    :open-on-focus="true"
                                    :searchable="true"
                                    :match-keys="['name']"
                                    search-nested
                                    clear-on-select
                                    :clearable="false"
                                    :always-open="false"
                                )
                                    label(
                                        slot="option-label"
                                        slot-scope="{ node }"
                                    ) {{ node.raw.name }}
                                    div(
                                        slot="value-label"
                                        slot-scope="{ node }"
                                    ) {{ getBreadcrumb(node.raw) }}
                            el-form-item(v-if="tagsEditable && tagOptions.length" :label="$t('Tags')" size="small")
                                el-select.is-full-width.dark(
                                    placeholder=""
                                    v-model="tags"
                                    value-key="id"
                                    size="small"
                                    effect="dark"
                                    multiple
                                )
                                    el-option(
                                        v-for="tag in tagOptions"
                                        :key="tag.key" :label="tag.name" :value="tag"
                                    )

                el-tab-pane(name="settings" :label="$t('Settings')")
                    .block-settings
                        .settings-wrap
                            include /components/Page/Sections/settings.pug
        .drawer-footer
            include /components/Page/Sections/section-drawer-footer.pug
</template>

<i18n>
{
    "en": {
        "Edit {section}": "Edit {section}"
    },
    "de": {
        "Edit {section}": "{section} bearbeiten",
        "Content": "Inhalt",
        "Settings": "Einstellungen",
        "Category": "Kategorie",
        "Categories": "Kategorien",
        "Tags": "Tags",
        "This shop has no categories yet!": "In diesem Shop gitb es noch keine Kategorien!",
        "Margin top": "Abstand oben",
        "Margin bottom": "Abstand unten",
        "none": "Ohne",
        "small": "Klein",
        "medium": "Mittel",
        "large": "Groß",
        "default": "Standard",
        "custom": "Benutzerdefiniert",
        "Everybody": "Jedem",
        "Members": "Mitgliedern",
        "Guests": "Gästen",
        "Any": "Alle",
        "Tags": "Tags",
        "Select tags": "Tags auswählen",
        "Accessible by": "Zugänglich von",
        "desktop": "Desktop",
        "tablet": "Tablet",
        "mobile": "Telefon",
        "Visible on":"Anzeigen auf",
        "Element is displayed on":"Inhaltselement <br> wird dargestellt auf"
    }
}
</i18n>

<script>
import _ from 'lodash';

import store from '@/store';
import { checkRestrictions } from '@/helpers';
import Section from '@/components/Page/Sections/Section';
import NestedSet from '@/nested-set-lib';

import Treeselect from '@riophae/vue-treeselect';

export default {
    name: 'CategoryProducts',
    extends: Section,
    components: {
        Treeselect
    },
    // filters: {
    // },
    computed: {
        editable() {
            return checkRestrictions('ex:shop');
        },
        // sections that only need categories (budget planning) turn the tag picker off
        tagsEditable() {
            return true;
        },
        isEmpty() {
            // let empty = !this.$slots.default
            let empty = true

            if (empty && this.section.shopCategories && this.section.shopCategories.length) empty = false
            if (empty && this.section.shopTags && this.section.shopTags.length) empty = false

            // if (empty && this.section.informations && this.section.informations.length) empty = false
            // if (empty && this.section.eventCategories && this.section.eventCategories.length) empty = false
            // if (empty && this.section.shopCategories && this.section.shopCategories.length) empty = false
            // if (empty && this.section.products && this.section.products.length) empty = false

            // const contents = _.get(this.section, 'contents') || []
            // contents.forEach(content => {
            //     if (! empty) return
            //     if (content.addresses && content.addresses.length) empty = false
            //     if (content.images && content.images.length) empty = false
            //     if (content.media && content.media.length) empty = false
            //     if (content.title || content.sub_title || content.text) empty = false
            // })

            return empty
        },
        categories: {
            get() {
                const section = this.drawer.section || this.section

                const categories = _.get(section, 'shopCategories') || [];
                return _.map(categories, 'id');
            },
            set(selection) {
                let categories = [];

                const section = this.drawer.section || this.section

                const options = _.get(this.options, 'extensions.shop.category.items') || [];
                if (selection && selection.length) {
                    selection.forEach((category) => {
                        const option = options.find(option => option.id === category);
                        if (option) categories.push(option);
                    });
                }

                // const payload = {
                //     i: this.i,
                //     // p: this.p,
                //     s: this.s,
                //     categories
                // };
                // store.commit(`${this.module}/extensions/shop/form/sectionCategories`, payload);

                this.$set(section, 'shopCategories', categories);
            }
        },
        tags: {
            get() {
                const section = this.drawer.section || this.section

                const tags = _.get(section, 'shopTags') || [];
                return tags
            },
            set(selection) {
                const section = this.drawer.section || this.section

                let tags = [];
                if (selection && selection.length) {
                    tags = selection.map(el => {
                        let tag = {
                            key: el.key,
                            name: el.name,
                        };

                        if (el.id) {
                            tag.id = el.id;
                        }

                        return tag;
                    });
                }

                this.$set(section, 'shopTags', tags);
            }
        },
        categoryOptions() {
            let tree = [];
            let items = _.get(this.options, 'extensions.shop.category.items') || [];

            if (items.length) {
                items = _.cloneDeep(items);
                tree = NestedSet.createTree(items);
            }

            return tree;
        },
        tagOptions() {
            return _.get(this.options, 'extensions.shop.tag.items') || [];
        },
    },
    methods: {
        getBreadcrumb(category) {
            let breadcrumb = category.name;

            const items = _.get(this.options, 'extensions.shop.category.items') || [];
            let ancestors = NestedSet.getAncestors(items, category);

            const validatedItems = NestedSet.validate(_.cloneDeep(items));
            ancestors = ancestors.filter(el => validatedItems.valid.IDs.includes(el.id));

            if (ancestors && ancestors.length) {
                ancestors = _.map(ancestors, 'name');
                breadcrumb = ancestors.join(' > ');
                breadcrumb += ` > ${category.name}`;
            }

            return breadcrumb;
        }
    }
};
</script>

<style lang="sass" scoped>
.preview
    .content-wrapper
        // margin-bottom: 8px
        & >
            .categories,
            .tags
                display: flex
                flex-wrap: wrap
                gap: 5px
                .el-tag + .el-tag
                    margin-left: 0

.viewports
    margin-right: 12px
    .el-tooltip
        margin: 0 3px
        color: #9ca3af
        .inner
            text-align: center

.tags
    margin-top: 4px
    .el-tag
        font-size: 0.7rem

.error
    margin-bottom: 10px
</style>
